/**
 * SuggestionChips -- clickable prompt buttons in the chat empty state.
 *
 * Shows onboarding-specific suggestions for new users, or general
 * suggestions for returning users.
 */

interface SuggestionChipsProps {
  onSend: (message: string) => void;
  isOnboarding: boolean;
}

const ONBOARDING_CHIPS = [
  "Set up my profile",
  "Create my first task",
  "What can you do?",
  "Plan my day",
];

const GENERAL_CHIPS = [
  "Plan my day",
  "Create a task",
  "Show my priorities",
  "What's overdue?",
];

export function SuggestionChips({ onSend, isOnboarding }: SuggestionChipsProps): React.ReactElement {
  const chips = isOnboarding ? ONBOARDING_CHIPS : GENERAL_CHIPS;

  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {chips.map((label) => (
        <button
          key={label}
          type="button"
          onClick={() => onSend(label)}
          className="bg-primary-subtle text-primary border border-primary/20 rounded-xl text-xs px-3 py-2 hover:bg-primary/20 transition-colors duration-100 cursor-pointer"
        >
          {label}
        </button>
      ))}
    </div>
  );
}
